export type DeviceFormData = {
	id: string;
	username: string;
	name: string;
	nodeId: string;
	desktopName: string;
	createdAt: string;
	updatedAt: string;
	config: any;
	deviceImageKey: string;
};

export const validation = (
	values: Partial<DeviceFormData>,
	key: keyof DeviceFormData | "all",
): {
	name: string;
	errors: Array<{ isValidated: boolean; message: string }>;
} => {
	if (!values) {
		return { name: "", errors: [] };
	}

	switch (key) {
		case "name":
			return {
				name: "Nome",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
				],
			};
		case "nodeId":
			return {
				name: "Node ID",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
				],
			};
		case "desktopName":
			return {
				name: "Desktop Name",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
				],
			};
		case "all": {
			let errors: Array<{ isValidated: boolean; message: string }> = [];
			for (const _key of Object.keys(values) as Array<keyof DeviceFormData>) {
				const validations = validation(values, _key);
				const newErrors = validations.errors.filter(
					(error) => !error.isValidated,
				);
				errors = [
					...errors,
					...newErrors.map((error) => ({
						...error,
						message: `${validations.name}: ${error.message}`,
					})),
				];
			}
			return {
				name: "Validação dos campos",
				errors,
			};
		}
		default:
			return { name: "", errors: [] };
	}
};
